export const pageTitle = {
  'Tracker Settings': '追踪设定',
  'Marketing & Tracker': '网店营销及追踪',
  'Add Event Tracker': '新增追踪工具',
  'Add Event Tracker_edit': '编辑追蹤工具',
  Apps: '扩充功能',
  'Apps Store': '扩充功能商店',
};
